// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__EHKvi","title":"ClientReferral_title__2_L8q","itemText":"ClientReferral_itemText__Qcg8T"};